// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/avatar/style/index.less
// module id = 1003
// module chunks = 1